import { useQuery } from "@tanstack/react-query";

import { useAuthenticationStore } from "../../../../domain/authentication/hooks/useAuthenticationStore";
import type { RpcClient } from "../../../../rpc-browser-sdk";
import { isDriverAppWebView } from "../../../../utils/isDriverAppWebView";

export function useDriverTermsAndConditionsRequiringAcceptance() {
    const authenticationStore = useAuthenticationStore();

    const isEligibleForTermsAndConditions = !isDriverAppWebView() && authenticationStore.isDriversCompany;

    const query = useQuery({
        queryKey: ["driverTermsAndConditions.getDriverTermsAndConditionsRequiringAcceptance"],
        queryFn: () => {
            // Importing getRpcClient dynamically to avoid circular dependencies
            const getRpcClient = require("../../../../rpc-browser-sdk").getRpcClient as () => RpcClient;
            return getRpcClient().driverTermsAndConditions.getDriverTermsAndConditionsRequiringAcceptance();
        },
        enabled: isEligibleForTermsAndConditions,
        networkMode: "always",
    });

    return {
        ...query,
        isLoading: query.isPending,
        data: isEligibleForTermsAndConditions ? query.data : null,
    };
}
